@if (assessment(); as definedAssessment) {
	<div class="contentContainer">
		<div class="header"><!-- layout placeholder --></div>

		<sim-exam-device-panel class="left">
			<h2 header>{{ T.EXAMINER_ASSESSMENT_DISPLAY_ASSESSMENT_INDEX_TITLE | translate }}</h2>
			@if (assessmentPanel().isFormInitialized()) {
				<sim-assessment-exam-index
					content
					class="index"
					[assessment]="assessmentPanel().$changedAssessment | async"
					[activeItemId]="assessmentPanel().currentItemId()"
					[activeGroupId]="assessmentPanel().currentGroupId()"
					(onItemClicked)="handleIndexItemClick($event)"
				/>
			}
		</sim-exam-device-panel>

		<sim-exam-device-panel class="center">
			<h1 header class="mat-h2">{{ definedAssessment.name }}</h1>
			<sim-assessment-answer-single-item-panel
				content
				class="assessment"
				[assessment]="definedAssessment"
				[mode]="definedAssessment.state === AssessmentState.InProgress ? AssessablePanelMode.Answer : AssessablePanelMode.View"
			/>
		</sim-exam-device-panel>

		<div class="right"><!-- layout placeholder --></div>
	</div>
}
